export default "<span>\n    {{ data.message }}\n</span>\n";